'use client'

import { getMarketWalletAddress } from '@/lib/wallets/registry'
import type { BridgePlatform, WalletRuntime } from '@/lib/wallets/types'
import { useWallet } from '@/providers/WalletContext'

export interface UseMarketAddressOptions {
	runtime?: Partial<WalletRuntime>
}

export function useMarketAddress(
	platform: BridgePlatform,
	options: UseMarketAddressOptions = {}
): string | undefined {
	const wallet = useWallet()
	const runtime: WalletRuntime = {
		eoaAddress: options.runtime?.eoaAddress ?? wallet.eoaAddress,
		solanaAddress: options.runtime?.solanaAddress ?? wallet.solanaAddress,
		addressOverrides: options.runtime?.addressOverrides,
		publicClient: options.runtime?.publicClient ?? wallet.publicClient,
		basePublicClient: options.runtime?.basePublicClient ?? wallet.basePublicClient,
		solanaConnection: options.runtime?.solanaConnection ?? wallet.solanaConnection,
		polymarketSafe: options.runtime?.polymarketSafe ?? wallet.polymarketSafe,
		polymarketActiveWallet:
			options.runtime?.polymarketActiveWallet ?? wallet.polymarketActiveWallet,
		userId: options.runtime?.userId ?? wallet.userId,
	}

	return getMarketWalletAddress(platform, runtime)
}
